const nakiRadioProductCategoryAbbreviations = {
    radioDevice: "radio-device",
    subscription: "subscription",
    subscriptionBundle: "subscription-bundle",
};

export default nakiRadioProductCategoryAbbreviations;
